export const SI_LANG = 'si';
export const EN_LANG = 'en';
export const TA_LANG = 'ta';
